// New method for checkout

import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import ShippingForm from "./shipping-form";
import Coupons from "./coupons";
import PaymentMethod from "./payments-methods";
import RedeemGiftCard from "./redeem-giftCardNew";
import VOCartPreview from "./VOPreview";
import BillingAddressDetails from "./billing-details";
import CODConfirm from "./cod-confirm";
import OrderStatus from "./order-status";
import TransactLoading from "./transact-loading";
import PageLoader from "../../common/PageLoader";

import Seo from "../../layouts/common/seo";
import Breadcrumb from "../../new_template_common/breadcrumb/BreadCrumb";
import { removeFromCart } from "../../../actions";

import useCheckout from "./useCheckout";

import "./shimmer.scss";
import "./checkout.css";
import classes from "./checkout-form.module.scss";

const CheckOut1 = (props) => {
  const {
    userDetails,
    setUserDetails,
    shippingDetails,
    setShippingDetails,
    billingDetails,
    setBillingDetails,
    message,
    setMessage,
    loadingVO,
    VOData,
    BillingShippingAddressSame,
    setBillingShippingAddressSame,
    inTransition,
    SelectedPaymentConfirmor,
    Order,
    OrderPayment,
    OrderResponse,
    remoteValidationTrace,
    setRemoteValidationTrace,
    BillingAddressBlockRef,
    syncCart,
    updateVO,
    submitCheckout,
    generate_order,
    confirm_order,
    clear_order,
    razorpayConfirm,
  } = useCheckout({
    cartItems: props.cartItems,
    profile_data: props.profile_data,
    extendedItems: props.extendedItems,
    history: props.history,
  });

  const [paymentSyncing, setPaymentSyncing] = useState(false);

  useEffect(() => {
    if (loadingVO || props.extendedItems.syncing) {
      setPaymentSyncing(false);
    }
  }, [loadingVO, props.extendedItems.syncing]);

  useEffect(() => {
    if (SelectedPaymentConfirmor === "online_payment_razorpay" && Order) {
      razorpayConfirm();
    }
  }, [SelectedPaymentConfirmor, Order]);

  useEffect(() => {
    document.body.classList.add("checkout-page");
    return () => {
      document.body.classList.remove("checkout-page");
    };
  }, []);

  return (
    <div className="site-main">
      <div
        data-component="checkout_main"
        className={`${classes.pageWrapper} ${OrderResponse != null ? " light-layout" : ""
          }`}
      >
        <Seo type="checkout-head" />

        <section className="custom-container">
          {message.description && (
            <div
              className="alert alert-danger"
              role="alert"
              style={{ cursor: "pointer" }}
              onClick={() => setMessage({ description: "" })}
            >
              {message.description}
            </div>
          )}
          <div className={classes.formContainer}>
            {OrderResponse == null && <Breadcrumb ancestor="Cart" ancestorLink="/cart" current="Checkout" />}
            {OrderResponse ? (
              <OrderStatus OrderResponse={OrderResponse} />
            ) : (
              <>
                {(loadingVO || props.extendedItems.syncing || paymentSyncing) && <PageLoader overlay />}
                <TransactLoading inTransition={inTransition} />
                {SelectedPaymentConfirmor === "payment_on_delivery" && Order && (
                  <CODConfirm
                    Order={Order}
                    OrderPayment={OrderPayment}
                    generate_order={generate_order}
                    confirm_order={confirm_order}
                    clear_order={clear_order}
                  />
                )}

                <div className={classes.checkoutLayout}>
                  <div className={classes.mainContainer}>
                    <div className={classes.card}>
                      <div>
                        <h3 className={classes.title}>Shipping Address</h3>
                        <p className={classes.subtitle}>
                          Provide your address for delivery.
                        </p>
                      </div>
                      <div>
                        <ShippingForm
                          userDetails={userDetails}
                          setUserDetails={setUserDetails}
                          shippingDetails={shippingDetails}
                          setShippingDetails={setShippingDetails}
                          validationTrace={remoteValidationTrace}
                          setValidationTrace={setRemoteValidationTrace}
                          VOData={VOData}
                          profile={props.profile_data}
                        />
                        <div ref={BillingAddressBlockRef}>
                          <BillingAddressDetails
                            VOData={VOData}
                            updateVO={updateVO}
                            profile={props.profile_data}
                            sameAddress={BillingShippingAddressSame}
                            setSameAddress={setBillingShippingAddressSame}
                            billingDetails={billingDetails}
                            setBillingDetails={setBillingDetails}
                            validationTrace={remoteValidationTrace}
                            setValidationTrace={setRemoteValidationTrace}
                          />
                        </div>
                      </div>
                    </div>

                    <div className={classes.promoWrapper}>
                      <Coupons
                        symbol={props.symbol}
                        VOData={VOData}
                        syncing={loadingVO}
                        updateVO={() => {
                          syncCart(updateVO);
                        }}
                      />
                      <RedeemGiftCard
                        VOData={VOData}
                        updateVO={() => {
                          syncCart(updateVO);
                        }}
                        syncing={loadingVO}
                      />
                    </div>
                    <PaymentMethod
                      VOData={VOData}
                      syncing={loadingVO || props.extendedItems.syncing}
                      onSyncStart={() => setPaymentSyncing(true)}
                      updateVO={() => {
                        syncCart(updateVO);
                      }}
                    />
                  </div>
                  <div className={classes.summary_wrap}>
                    <VOCartPreview
                      userDetails={userDetails}
                      shippingDetails={shippingDetails}
                      symbol={props.symbol}
                      removeFromCart={props.removeFromCart}
                      cart={props.extendedItems.list}
                      syncing={loadingVO || props.extendedItems.syncing}
                      VOData={VOData}
                      updateVO={submitCheckout}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        </section>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  cartItems: state.cartList.cart,
  extendedItems: state.cartList.extended_cart,
  profile_data: state.data.profile_data,
  symbol: state.data.symbol,
});

export default connect(mapStateToProps, {
  removeFromCart,
})(CheckOut1);
